import { c as _c } from "react/compiler-runtime";
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import RatioContainer from 'components/consumer/RatioContainer';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import useScreen from 'hooks/useScreen';
const PDPFullScreenGalleryListItem = t0 => {
  const $ = _c(29);
  const {
    closeFullScreenGallery,
    cropData,
    displayShownIn: t1,
    enableCrops,
    type,
    is2MobileColumns,
    isEditOrder,
    isMobile,
    onClick,
    optionId,
    productName: t2,
    src,
    upholsteryName,
    valueId
  } = t0;
  const displayShownIn = t1 === undefined ? false : t1;
  const productName = t2 === undefined ? null : t2;
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const {
    isTabletOrDesktop
  } = useScreen();
  const ImageWrapper = isMobile && is2MobileColumns ? RatioContainer : Fragment;
  const desktopImageSizesProps = useFixedWidthContainerSizeProps();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sizes: "100vw"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const mobileImageSizesProps = t3;
  const imageSizesProps = isTabletOrDesktop ? desktopImageSizesProps : mobileImageSizesProps;
  let t4;
  if ($[1] !== is2MobileColumns) {
    t4 = cx("mx-auto my-0", {
      "max-[767px]:bottom-0 max-[767px]:h-full max-[767px]:left-0 max-[767px]:object-contain max-[767px]:absolute max-[767px]:right-0 max-[767px]:top-0": is2MobileColumns
    });
    $[1] = is2MobileColumns;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = is2MobileColumns ? "1:1" : undefined;
  const t6 = is2MobileColumns ? "1x1" : null;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = isFail => !isFail && setIsImageLoaded(true);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== cropData || $[5] !== enableCrops || $[6] !== imageSizesProps || $[7] !== onClick || $[8] !== src || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== type) {
    t8 = <JBProductImage className={t4} crops={cropData} isFullScreenGallery={true} src={src} {...imageSizesProps} enableCrops={enableCrops} type={type} ar={t5} cropFormat={t6} onClick={onClick} onLoad={t7} />;
    $[4] = cropData;
    $[5] = enableCrops;
    $[6] = imageSizesProps;
    $[7] = onClick;
    $[8] = src;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = type;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== closeFullScreenGallery || $[15] !== displayShownIn || $[16] !== isEditOrder || $[17] !== isImageLoaded || $[18] !== isMobile || $[19] !== isTabletOrDesktop || $[20] !== optionId || $[21] !== productName || $[22] !== upholsteryName || $[23] !== valueId) {
    t9 = (isTabletOrDesktop && isImageLoaded && optionId && valueId && upholsteryName || displayShownIn && upholsteryName && optionId && isImageLoaded) && <div className={cx("bg-white right-0 bottom-0 p-2.5 rounded-none", {
      absolute: !(isMobile && displayShownIn),
      static: isMobile && displayShownIn
    })}><PDPShownIn isEditOrder={isEditOrder} optionId={optionId} valueId={valueId} upholsteryName={upholsteryName} onSelection={closeFullScreenGallery} productName={productName} layout={isMobile && displayShownIn ? "roundSwatchLabel" : ""} showInactiveUpholstery={isMobile && displayShownIn} /></div>;
    $[14] = closeFullScreenGallery;
    $[15] = displayShownIn;
    $[16] = isEditOrder;
    $[17] = isImageLoaded;
    $[18] = isMobile;
    $[19] = isTabletOrDesktop;
    $[20] = optionId;
    $[21] = productName;
    $[22] = upholsteryName;
    $[23] = valueId;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== ImageWrapper || $[26] !== t8 || $[27] !== t9) {
    t10 = <div className="relative"><ImageWrapper>{t8}{t9}</ImageWrapper></div>;
    $[25] = ImageWrapper;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
PDPFullScreenGalleryListItem.propTypes = {
  closeFullScreenGallery: PropTypes.func,
  cropData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  is2MobileColumns: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
  optionId: PropTypes.number,
  productName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  src: PropTypes.string,
  type: PropTypes.string,
  upholsteryName: PropTypes.string,
  valueId: PropTypes.number
};
export default PDPFullScreenGalleryListItem;